import React from 'react';
import styled from './StatusNotOk.module.css';
import statusNotOk from '../../../../assets/images/statusNotOkIcon.svg';

const StatusNotOk: React.FC = () => {
    return <img src={statusNotOk} alt="Status Not Ok" className={styled.Img} />;
};

export default StatusNotOk;
